import { map, first, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import * as _ from 'lodash';
import { StreamService } from './stream.service';
import { UserService } from './user.service';

@Injectable({ providedIn: 'root' })
export class UncategorizedGuard implements CanActivate {
    
    constructor(private streamService: StreamService, private userService: UserService, private router:Router) { }

    isTargetUrl = (url: string) => url.indexOf('/login') === -1 && url.indexOf('/categories/uncategorized/topics/') !== -1;

    fullUrl = route => [this.pathify(route.pathFromRoot), this.pathify(route.children)].filter(path => path.trim() !== '').join('/');

    pathify = route => route.map(rt => rt.url.join('/')).join('/');

    checkStream = (topicId, route: ActivatedRouteSnapshot) => this.streamService.getStream(topicId)
        .pipe(
            first(),
            map(stream => {
                if (stream.taxonomicMemberships && stream.taxonomicMemberships.length > 0) {
                    let targetUrl = this.fullUrl(route).replace('uncategorized', stream.taxonomicMemberships[0])
                    if (!_.isEmpty(route.queryParams)) {
                        const params = new URLSearchParams();
                        for (let key in route.queryParams) {
                            params.set(key, route.queryParams[key]);
                        }
                        targetUrl = targetUrl + '?' + params.toString();
                    }
                    this.router.navigateByUrl(targetUrl);
                    return false;
                } 
                return true;
            })
        );
    
    canActivate = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
        if (this.userService.getCurrentUser() && this.isTargetUrl(this.fullUrl(route))) {
            return this.checkStream(route.params.topicId, route);
        } else if(this.isTargetUrl(this.fullUrl(route))) {
            return this.userService.isLoggedIn()
            .pipe(
                first(),
                mergeMap(res => res.user ? this.checkStream(route.params.topicId, route) : of(true))
            );
        }
        return true;
    };
}
